import { render, staticRenderFns } from "./ChefiaValidacaoLicencaPremio.vue?vue&type=template&id=09be70c2&scoped=true&"
import script from "./ChefiaValidacaoLicencaPremio.vue?vue&type=script&lang=js&"
export * from "./ChefiaValidacaoLicencaPremio.vue?vue&type=script&lang=js&"
import style0 from "./ChefiaValidacaoLicencaPremio.vue?vue&type=style&index=0&id=09be70c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be70c2",
  null
  
)

export default component.exports